export default "__VITE_ASSET__NsrksIBe__"